// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1TDJU","flex":"flex___38GgX","label":"label___2NxB2","left":"left___3EjGh","full":"full___3jsB6"};